import { useSignalRHub, type ConnectionStatus } from '@/realtime/useSignalRHub';

// Feed Monitoring hub (/hubs/feed-monitoring). The hub only pings — Subscribe() on
// connect, server fires payload-less OnFeedMonitoringChanged every 5s; the client
// pulls GET live-monitoring on each ping. Mirrors LiveMonitoring/index.js.
export function useFeedMonitoringLive({
  enabled,
  onChanged,
  onError,
}: {
  enabled: boolean;
  onChanged: () => void;
  onError?: () => void;
}): { status: ConnectionStatus } {
  const { status } = useSignalRHub({
    url: '/hubs/feed-monitoring',
    enabled,
    on: {
      OnFeedMonitoringChanged: () => onChanged(),
    },
    onConnected: (conn) => {
      // Subscribe → the hub also PublishNowAsync (fires OnFeedMonitoringChanged),
      // so one immediate refresh happens via the event handler. Pull once here too
      // in case negotiation and the first tick race.
      void conn
        .invoke('Subscribe')
        .then(() => onChanged())
        .catch(() => onError?.());
    },
  });
  return { status };
}
